import { render, staticRenderFns } from "./WorkingAverageDetail.vue?vue&type=template&id=1bb588e4&"
import script from "./WorkingAverageDetail.vue?vue&type=script&lang=js&"
export * from "./WorkingAverageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports